<template>
  <div style="padding: 30px;">
    <div style="background-color: rgba(41, 155, 255, 0.1); padding: 30px;">
      <div style="color: rgb(7, 230, 248);">
        大屏标题设置
        <a type="text" size="mini" @touchstart="updateBigScreenTitle()" @click="updateBigScreenTitle()"
           style="color:#299FFB; cursor: pointer; float: right;">
          编辑
        </a>
      </div>
      <el-row style="margin-left: 1%; margin-top: 20px;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="10">大屏标题：</el-col>
        <el-col :lg="10" :md="10" :sm="13" :xl="10" :xs="13">
          {{ big_screen_title.val1 }}
        </el-col>
      </el-row>
      <el-row style="margin-left: 1%; margin-top: 20px;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="10">大屏简称：</el-col>
        <el-col :xl="10" :lg="10" :md="10" :sm="13" :xs="13">
          {{ big_screen_abbreviation.val1 }}
        </el-col>
      </el-row>
    </div>
    <div style="background-color: rgba(41, 155, 255, 0.1); margin-top: 20px; padding: 30px;">
      <div style="color: rgb(7, 230, 248);">
        大屏模板设置
      </div>
      <el-row style="margin-left: 1%; margin-top: 2%;">
        <el-col :xl="2" :lg="2" :md="3" :sm="4" :xs="10">大屏模板：</el-col>
        <el-col :xl="18" :lg="18" :md="18" :sm="18" :xs="24">
          <el-col :xl="6" :lg="8" :md="12" :sm="12" :xs="24" v-for="item in large_screen_template" :key="item.id">
            <div class="largeScreen" @touchstart="updateLargeScreenTemplate(item)" @click="updateLargeScreenTemplate(item)">
              <div :style="iconImage($ftpUrl+item.icon1)">
                <div class="flex" :style="stateImage(item.val1)">
                  <div style="margin-top: 10px">
                     <span style="color: white;">
                      {{item.val1 === 'true'? '启 用':'禁 用'}}
                     </span>
                  </div>
                </div>
              </div>
              <div class="caption" style="text-align: center; font-weight:bold; margin-top: 5px;">{{item.name}}{{$ftpUrl+item.icon1}}</div>
            </div>
          </el-col>
        </el-col>
      </el-row>
    </div>

    <!--    弹出窗-->
    <function-dialog-component
        :dialog-title="title"
        :dialogVisible.sync="LargeSizeScreenDialogVisible"
        @dialogClose="(data) => this.LargeSizeScreenDialogVisible = data"
        center
        width="35vw">
      <div slot="content" style="padding: 10px 30px 20px 30px;height: 20vh">
        <edit-big-screen-title
          :bigScreenTitleData="edit_big_screen_title"
          :bigScreenAbbreviationData="edit_big_screen_abbreviation"/>
      </div>

      <div class="dialog-footer" slot="footer" style="text-align: center; margin-top: 5px; margin-bottom: 15px;">
        <el-button @touchstart="() => {this.LargeSizeScreenDialogVisible = false;}" @click="() => {this.LargeSizeScreenDialogVisible = false;}" size="mini">关 闭</el-button>
        <el-button @touchstart="commitLargeSizeScreen" @click="commitLargeSizeScreen" size="mini" type="primary">保 存</el-button>
      </div>
    </function-dialog-component>
  </div>
</template>

<script>
import {getSystematicByParentCodes, preservationAndQuerySystematic, saveOrUpdateSystematic} from "@/network/systematic";
import editBigScreenTitle from "@/views/basic_operations/sys_setting/large_size_screen/editBigScreenTitle";
import FunctionDialogComponent from "@/components/FunctionDialogComponent";
import image0 from "@/assets/images/sys-setting/large-size-screen/0.png";
import image1 from "@/assets/images/sys-setting/large-size-screen/1.png";

export default {
  name: "LargeSizeScreen",
  components: {FunctionDialogComponent, editBigScreenTitle},
  data() {
    return {
      LargeSizeScreen: {},
      big_screen_title: {},
      big_screen_abbreviation: {},
      large_screen_template: [],

      edit_big_screen_title: {}, //修改大屏标题
      edit_big_screen_abbreviation: {}, //修改大屏简称
      update_large_screen_template: {}, //修改的大屏模板
      currently_selected_large_screen_template: {}, //当前选中的大屏模板

      title: "",
      LargeSizeScreenDialogVisible: false,

      extSystematic: {
        parentId: 0,
        code: "",
        name: "",
        val1: "",
        val2: "",
        ordinal: "",
        isDisplay: true,
        icon1: "",
        icon2: "",
        note: "",
        spare: "",
        manageable: true,
        largeScreenTemplateSwitching: false, //大屏模板切换
      },

      codes: ["large_size_screen","large_screen_template"],

    }
  },
  created() {
    this.getLargeSizeScreen();
  },
  methods:{
    getLargeSizeScreen(){
      getSystematicByParentCodes(this.codes).then(res => {
        this.large_screen_template = [];
        this.LargeSizeScreen = res.data;
        console.log("大屏配置参数：", this.LargeSizeScreen);
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].code === "big_screen_title") {
            this.big_screen_title = res.data[i];
          } else if (res.data[i].code === "big_screen_abbreviation") {
            this.big_screen_abbreviation = res.data[i];
          } else {
            this.large_screen_template.push(res.data[i]);
            if (res.data[i].val1 === "true") {
              this.currently_selected_large_screen_template = res.data[i];
            }
          }
        }
      })
    },

    //编辑
    updateBigScreenTitle(){
      this.title = '编辑大屏标题';
      this.edit_big_screen_title = JSON.parse(JSON.stringify(this.big_screen_title));
      this.edit_big_screen_abbreviation = JSON.parse(JSON.stringify(this.big_screen_abbreviation));
      this.LargeSizeScreenDialogVisible = true;
    },

    //保存
    commitLargeSizeScreen(){
      //保存父配置
      this.extSystematic.code = "large_size_screen";
      this.extSystematic.name = "大屏配置";
      preservationAndQuerySystematic(this.extSystematic.parentId,this.extSystematic.code,this.extSystematic.name,this.extSystematic.val1,this.extSystematic.val2,
          this.extSystematic.icon1,this.extSystematic.icon2).then(res =>{
        console.log("保存大屏配置返回参数：",res);
        if (res.code === 0) {
          this.edit_big_screen_title.parentId = res.data.id;
          this.edit_big_screen_abbreviation.parentId = res.data.id;
          this.commitSon();
        }
      })
    },

    //保存子配置
    commitSon(){
      let extSystematicList = [];
      extSystematicList.push(this.edit_big_screen_title);
      extSystematicList.push(this.edit_big_screen_abbreviation);
      console.log("请求参数：",extSystematicList);
      saveOrUpdateSystematic(extSystematicList).then(res =>{
        console.log("保存系统子配置返回参数：",res);
        if (res.code === 0){
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.getLargeSizeScreen();
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
        this.LargeSizeScreenDialogVisible = false;
      })
    },

    //修改大屏模板 --保存并查询父类
    updateLargeScreenTemplate(row){
      if (this.largeScreenTemplateSwitching){
        this.$message({
          message: '大屏模板正在切换请稍后',
          type: 'warning'
        });
        return;
      }
      this.largeScreenTemplateSwitching = true;
      this.extSystematic.code = "large_screen_template";
      this.extSystematic.name = "大屏模板配置";
      preservationAndQuerySystematic(this.extSystematic.parentId,this.extSystematic.code,this.extSystematic.name,this.extSystematic.val1,this.extSystematic.val2,
          this.extSystematic.icon1,this.extSystematic.icon2).then(res =>{
        console.log("保存大屏模板配置返回参数：",res);
        if (res.code === 0){
          this.updateLargeScreenTemplateSon(res,row);
        }
      })
    },

    //修改大屏模板
    updateLargeScreenTemplateSon(res,row){
      for(var i=0; i<this.large_screen_template.length; i++){
        if (this.large_screen_template[i].id === row.id) {
          this.large_screen_template[i].val1 = "true";
        } else {
          this.large_screen_template[i].val1 = "false";
        }
        this.large_screen_template[i].parentId = res.data.id;
      }
      console.log("请求参数：",this.large_screen_template);
      saveOrUpdateSystematic(this.large_screen_template).then(res =>{
        console.log("保存系统子配置返回参数：",res);
        if (res.code === 0) {
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.getLargeSizeScreen();
          this.largeScreenTemplateSwitching = false;
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          });
          this.largeScreenTemplateSwitching = false;
        }

      })
    },

    //模板
    iconImage(icon){
      return `
          width: 90%;
          height: 150px;
          margin: auto;
          margin-top: 10px;
          background: no-repeat center top;
          background-size: contain;
          background-image: url(`+icon+`);
          `;
    },

    //模板状态图
    stateImage(value){
      var image = image1;
      if (value === 'true') {
        image = image0;
      }
      return `
          backgroundImage: url(`+image+`);
          width: 46px;
          height: 55px;
          positiossn: absolute;
          top: 5px;
          float: left;
          text-align: center;
          `;
    }
  },

}
</script>

<style scoped>
  .largeScreen{
    height: 200px;
    margin-left: 40px;
    margin-top: 50px;
    position: relative;
    border: 1px solid  rgba(41, 155, 255, .1);
    background-color: rgba(41, 155, 255, .1);
  }
</style>
